import { Filter } from 'lucide-react'
import { useState } from 'react'

import FilterManagementDropdown from 'components/brokers/needs_attention/FilterManagementDropdown'
import { type MultipleSelectedValuesFilter } from 'components/brokers/types'
import ComboboxMultiSelectFilter, {
  type ComboboxFilterOption,
} from 'components/reusable/table/ComboboxMultiSelectFilter'

interface ReasonsFilterProps extends MultipleSelectedValuesFilter {
  availableReasons?: string[]
}

const ReasonsFilter = (props: ReasonsFilterProps) => {
  const [query, setQuery] = useState('')

  const reasonOptions: ComboboxFilterOption<string>[] = (
    props.availableReasons || []
  ).map((reason) => ({
    value: reason,
    label: reason
      .split('_')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' '),
  }))

  const filteredOptions = reasonOptions.filter(
    (option) =>
      (option.label || '').toLowerCase().includes(query.toLowerCase()) ||
      option.value.toLowerCase().includes(query.toLowerCase())
  )

  return (
    <ComboboxMultiSelectFilter
      {...props}
      options={[{ groupLabel: 'Reasons', options: filteredOptions }]}
      placeholder='Search reasons to filter...'
      onValueChange={setQuery}
    >
      <FilterManagementDropdown
        {...props}
        options={reasonOptions}
        noSelectionText='Reasons'
        pluralIdentifier='reasons'
      >
        <Filter size={20} />
      </FilterManagementDropdown>
    </ComboboxMultiSelectFilter>
  )
}

export default ReasonsFilter
